//import angular from 'angular';
/**
 * CustomBadgePrint
 */
angular.module('relivConference').directive(
    'customBadgePrintDirective',
    function () {
        return {
            scope: {},
            link: function ($scope) {
                $scope.ticket = {
                    rcnOnBadge: '',
                    displayName: '',
                    city: '',
                    stateCountry: '',
                };
            },
            template: require('./custom-badge-print-directive.html'),
        };
    }
);
